import { Box, Text, Group } from '@mantine/core'

export function StatusMeter({ label, value, color = 'cyan' }) {
  const percent = Math.min(100, Math.max(0, value))
  const colorMap = {
    cyan: { bar: '#00e5ff', glow: 'rgba(0, 229, 255, 0.4)' },
    green: { bar: '#00e676', glow: 'rgba(0, 230, 118, 0.4)' },
    orange: { bar: '#ff9100', glow: 'rgba(255, 145, 0, 0.4)' },
    red: { bar: '#ff1744', glow: 'rgba(255, 23, 68, 0.4)' },
  }
  const c = colorMap[color] || colorMap.cyan

  return (
    <Box>
      {label && (
        <Group justify="space-between" mb={4}>
          <Text size="xs" c="dimmed" ff="Rajdhani, sans-serif" fw={600}>
            {label}
          </Text>
          <Text size="xs" c={`${color}.4`} fw={700}>
            {Math.round(percent)}%
          </Text>
        </Group>
      )}
      <Box
        style={{
          height: 6,
          borderRadius: 3,
          background: 'rgba(255, 255, 255, 0.08)',
          overflow: 'hidden',
        }}
      >
        <Box
          className="glow-pulse"
          style={{
            height: '100%',
            width: `${percent}%`,
            borderRadius: 3,
            background: c.bar,
            boxShadow: `0 0 8px ${c.glow}`,
            transition: 'width 0.5s ease',
          }}
        />
      </Box>
    </Box>
  )
}
